import { handleErrors } from "@/utils/handle-errors";
import fetch from "@mv/flow-shared-utils/functions/fetch";
import { SdkUserGroup } from "@/interfaces/sdk-user-group";
export const saveUserGroupController = (userGroup: SdkUserGroup) => ({ type: "saveUserGroupController", userGroup });
export const updateUserGroupController = (userGroup: SdkUserGroup) => ({ type: "updateUserGroupController", userGroup });
export const loadAllUserGroupController = () => ({ type: "loadAllUserGroupController" });
export const loadUserGroupController = (userGroupControllerId: number) => ({ type: "loadUserGroupController", userGroupControllerId });
export const deleteUserGroupController = (userGroupId: number, userName: string) => ({ type: "deleteUserGroupController", userGroupId, userName });
// - user-access-controller
export const actions = {
  saveUserGroupController(_state: any, { userGroup }: { userGroup: SdkUserGroup }) {
    return fetch(`core/api/usergroup`, {
      method: "POST",
      body: JSON.stringify(userGroup),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  updateUserGroupController(_state: any, { userGroup }: { userGroup: SdkUserGroup }) {
    return fetch(`core/api/usergroup`, {
      method: "PUT",
      body: JSON.stringify(userGroup),
    })
      .then(handleErrors)
      .then((data) => data);
  },

  loadUserGroupController(_context: any, { userGroupControllerId }: { userGroupControllerId: number }) {
    return fetch(`core/api/usergroup/group/${userGroupControllerId}`)
      .then(handleErrors)
      .then((data) => data);
  },

  deleteUserGroupController(_context: any, { userGroupId, userName }: { userGroupId: number; userName: string }) {
    return fetch(`core/api/usergroup/${userGroupId}/${userName}`, {
      method: "DELETE",
    }).then(handleErrors);
  },

  loadAllUserGroupController() {
    return fetch(`core/api/usergroup`)
      .then(handleErrors)
      .then((data) => data);
  },
};
